import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = (err, options = {}) => {
	let errorMsg = "";

	if (typeof err === "string") {
		errorMsg = err;
	} else if (err?.response?.data?.error) {
		errorMsg = err.response.data.error;
	} else if (err?.response?.data?.message) {
		errorMsg = err.response.data.message;
	} else if (err?.message) {
		errorMsg = err.message;
	}

	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				...options,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
				...options,
			});
		}
	} else {
		toast.error("An error occurred!", {
			toastId: "generic-error",
			...options,
		});
	}
};

export default toastError;


/* const toastError = err => {
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		toast.error("An error occurred!");
	}
};

export default toastError; */
